"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaGroupList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const backendImport_2 = require("../../../../backendImport");
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => !x.isDirectMessagesMode() && !x.isEmailMode(), (0, fast_element_1.html) `
<div class="row mb-3">
    <div class="col-sm-3">
        <div class="comms-group-list-actions wa-gd-sidebar-footer border-top p-2 d-flex gap-2">
            <button type="button" class="btn btn-outline-primary btn-sm flex-grow-1" @click="${x => x.openJoinModal()}"
                ?disabled="${x => !x.agentActive}">
                <i class="simple-icon-login mr-1"></i>${'whatsapp.groups.joinGroup'.t()}
            </button>
            <button type="button" class="ml-2 btn btn-primary btn-sm flex-grow-1" @click="${x => x.goToCreateGroup()}"
                ?disabled="${x => !x.agentActive}">
                <i class="simple-icon-plus mr-1"></i>${'whatsapp.groups.addGroup'.t()}
            </button>
        </div>
    </div>    
</div>
`)}
<div class="wa-groups-dashboard">    
    
    <aside class="wa-gd-sidebar">

        <div class="wa-gd-sidebar-header border-bottom p-3">
            <div class="position-relative mb-2">
                <i class="simple-icon-magnifier position-absolute text-muted"
                    style="left: 10px; top: 50%; transform: translateY(-50%); font-size: 0.75rem;"></i>
                <input type="text" class="form-control form-control-sm wa-gd-search" :value="${x => x.search}"
                    @input="${(x, c) => x.handleSearchInput(c.event)}"
                    placeholder="${'whatsapp.dashboard.search'.t()}" />
            </div>
            ${(0, fast_element_1.when)(x => !x.isDirectMessagesMode() && !x.isEmailMode(), (0, fast_element_1.html) `
            <div class="comms-group-list-filters btn-group w-100" role="group">
                <button type="button" class="wa-gd-filter-btn ${x => x.filter === 'all' ? 'active' : ''}"
                    @click="${x => x.setFilter('all')}">
                    ${'whatsapp.dashboard.filterAll'.t()} <span class="wa-gd-count">${x => x.groups.length}</span>
                </button>
                <button type="button" class="wa-gd-filter-btn ${x => x.filter === 'critical' ? 'active' : ''}"
                    @click="${x => x.setFilter('critical')}">
                    ${'whatsapp.dashboard.filterCritical'.t()} <span class="wa-gd-count">${x => x.criticalGroupCount}</span>
                </button>
                <button type="button" class="wa-gd-filter-btn ${x => x.filter === 'action' ? 'active' : ''}"
                    @click="${x => x.setFilter('action')}">
                    ${'whatsapp.dashboard.filterWarning'.t()} <span class="wa-gd-count">${x => x.actionGroupCount}</span>
                </button>
            </div>
            `)}
            ${(0, fast_element_1.when)(x => x.isDirectMessagesMode(), (0, fast_element_1.html) `
            <div class="d-flex align-items-center justify-content-between">
                <span class="text-muted small">${'whatsapp.directMessages.contacts'.t()}: <strong>${x => x.dmContacts.length}</strong></span>
            </div>
            `)}
            ${(0, fast_element_1.when)(x => x.isEmailMode(), (0, fast_element_1.html) `
            <div class="d-flex align-items-center justify-content-between">
                <span class="text-muted small">${'whatsapp.email.contacts'.t()}: <strong>${x => x.emailContacts.length}</strong></span>
            </div>
            `)}
        </div>

        <div class="comms-group-list-contact-list wa-gd-sidebar-list" ${(0, fast_element_1.ref)('groupListElement')}>
            ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
            <div class="text-center p-4"><app-loader block="true" width="20px" height="20px"></app-loader></div>
            `)}

            
            ${(0, fast_element_1.when)(x => !x.loading && !x.isDirectMessagesMode() && !x.isEmailMode() && x.filteredGroups.length === 0, (0, fast_element_1.html) `
            <div class="p-3 text-muted small text-center">${'whatsapp.groups.noGroups'.t()}</div>
            `)}
            ${(0, fast_element_1.when)(x => !x.loading && !x.isDirectMessagesMode() && !x.isEmailMode(), (0, fast_element_1.html) `
                ${(0, fast_element_1.repeat)(x => x.filteredGroups, (0, fast_element_1.html) `
                <button type="button" class="comms-group-list-contact-position wa-gd-sidebar-item"
                    @click="${(g, c) => c.parent.selectGroup(g)}">
                    <div class="d-flex align-items-center">
                        <div class="wa-gd-avatar mr-2 text-white font-weight-bold"
                            :style="${(g, c) => c.parent.getStatusBgStyle(c.parent.getGroupLatestLogType(g.id))}">
                            ${g => (g.groupName || '?').charAt(0).toUpperCase()}
                        </div>
                        <div class="sidebar-item-content">
                            <div class="item-header">
                                <h6 class="item-name mb-0">${g => g.groupName}</h6>
                                <div class="item-badges">
                                    ${(0, fast_element_1.when)(g => g.tracking, (0, fast_element_1.html) `
                                        <span class="badge-tracking-sm">${'whatsapp.groups.tracking.badge'.t()}</span>
                                    `)}
                                    <span class="badge-comms-sm ${g => g.communicationType === 'TELE' ? 'tele' : 'wa'}">${g => g.communicationType === 'TELE' ? 'whatsapp.groups.communicationType.tele'.t() : 'whatsapp.groups.communicationType.wa'.t()}</span>
                                    <span class="item-status">
                                        <span class="status-dot-sm"
                                            :style="${(g, c) => c.parent.getStatusBgStyle(c.parent.getGroupLatestLogType(g.id))}"></span>
                                        <span class="status-label"
                                            :style="${(g, c) => c.parent.getStatusColorStyle(c.parent.getGroupLatestLogType(g.id))}">${(g, c) => c.parent.getStatusLabel(c.parent.getGroupLatestLogType(g.id))}</span>
                                    </span>
                                </div>
                            </div>
                            <p class="item-comment mb-0">${g => g.groupStatusComment || '—'}</p>
                        </div>
                    </div>
                </button>
                `)}
                ${(0, fast_element_1.when)((x) => !x.allGroupsLoaded, (0, fast_element_1.html) `
                    <div class="p-3 text-muted small text-center loading_groups">${'whatsapp.groups.loading_groups'.t()}</div>
                `)}
            `)}

            
            ${(0, fast_element_1.when)(x => !x.loading && x.isDirectMessagesMode() && x.filteredDmContacts.length === 0, (0, fast_element_1.html) `
            <div class="p-3 text-muted small text-center">${'whatsapp.directMessages.noContacts'.t()}</div>
            `)}
            ${(0, fast_element_1.when)(x => !x.loading && x.isDirectMessagesMode(), (0, fast_element_1.html) `
            ${(0, fast_element_1.repeat)(x => x.filteredDmContacts, (0, fast_element_1.html) `
            <button type="button" class="comms-group-list-contact-position wa-gd-sidebar-item"
                @click="${(c, ctx) => ctx.parent.selectDmContact(c)}">
                <div class="d-flex align-items-center">
                    <div class="wa-gd-avatar mr-2 text-white font-weight-bold"
                        :style="${(c, ctx) => ctx.parent.getStatusBgStyle(ctx.parent.getDmContactLatestLogType(c.authorLid))}">
                        ${c => (c.authorName || c.authorLid || '?').charAt(0).toUpperCase()}
                    </div>
                    <div class="sidebar-item-content">
                        <div class="item-header">
                            <h6 class="item-name mb-0">${c => c.authorName || c.authorLid}</h6>
                            <div class="item-badges">
                                <span class="badge-count-sm">${c => c.messageCount}</span>
                                <span class="item-status">
                                    <span class="status-dot-sm"
                                        :style="${(c, ctx) => ctx.parent.getStatusBgStyle(ctx.parent.getDmContactLatestLogType(c.authorLid))}"></span>
                                    <span class="status-label"
                                        :style="${(c, ctx) => ctx.parent.getStatusColorStyle(ctx.parent.getDmContactLatestLogType(c.authorLid))}">${(c, ctx) => ctx.parent.getStatusLabel(ctx.parent.getDmContactLatestLogType(c.authorLid))}</span>
                                </span>
                            </div>
                        </div>
                        <p class="item-comment mb-0">${c => c.lastMessage || '—'}</p>
                    </div>
                </div>
            </button>
            `)}
            `)}

            
            ${(0, fast_element_1.when)(x => !x.loading && x.isEmailMode() && x.filteredEmailContacts.length === 0, (0, fast_element_1.html) `
            <div class="p-3 text-muted small text-center">${'whatsapp.email.noContacts'.t()}</div>
            `)}
            ${(0, fast_element_1.when)(x => !x.loading && x.isEmailMode(), (0, fast_element_1.html) `
            ${(0, fast_element_1.repeat)(x => x.filteredEmailContacts, (0, fast_element_1.html) `
            <button type="button" class="comms-group-list-contact-position wa-gd-sidebar-item"
                @click="${(c, ctx) => ctx.parent.selectEmailContact(c)}">
                <div class="d-flex align-items-center">
                    <div class="wa-gd-avatar mr-2 text-white font-weight-bold"
                        :style="${(c, ctx) => ctx.parent.getStatusBgStyle(ctx.parent.getEmailContactLatestLogType(c.emailAddress))}">
                        ${c => (c.senderName || c.emailAddress || '?').charAt(0).toUpperCase()}
                    </div>
                    <div class="sidebar-item-content">
                        <div class="item-header">
                            <h6 class="item-name mb-0">${c => c.senderName || c.emailAddress}</h6>
                            <div class="item-badges">
                                <span class="badge-count-info">${c => c.messageCount}</span>
                                <span class="item-status">
                                    <span class="status-dot-sm"
                                        :style="${(c, ctx) => ctx.parent.getStatusBgStyle(ctx.parent.getEmailContactLatestLogType(c.emailAddress))}"></span>
                                    <span class="status-label"
                                        :style="${(c, ctx) => ctx.parent.getStatusColorStyle(ctx.parent.getEmailContactLatestLogType(c.emailAddress))}">${(c, ctx) => ctx.parent.getStatusLabel(ctx.parent.getEmailContactLatestLogType(c.emailAddress))}</span>
                                </span>
                            </div>
                        </div>
                        <p class="item-comment mb-0">${c => c.lastSubject || '—'}</p>
                    </div>
                </div>
            </button>
            `)}
            `)}
        </div>

    </aside>

    
    <div class="wa-gd-center">

        
        ${(0, fast_element_1.when)(x => !x.isDirectMessagesMode() && !x.isEmailMode(), (0, fast_element_1.html) `
        <comms-stats-alerts
            ${(0, fast_element_1.ref)('statsAlerts')}
            mode="groups"
            :items="${x => x.groups}"
            :trackLogs="${x => x.countLogs}">
        </comms-stats-alerts>
        `)}

        
        ${(0, fast_element_1.when)(x => !x.isDirectMessagesMode() && !x.isEmailMode() && x.settingsId, (0, fast_element_1.html) `
        <track-logs
            settingsId="${x => String(x.settingsId)}"
            mode="groups"
            :groupId="${x => x.selectedGroup ? x.selectedGroup.id : null}"
            :headerTitle="${x => x.selectedGroup ? x.selectedGroup.groupName + ' — ' + 'whatsapp.groups.trackLogs'.t() : 'whatsapp.groups.trackLogs'.t()}"
            :showBackButton="${x => !!x.selectedGroup}"
            :showOpenButton="${x => !!x.selectedGroup}"
            headerIcon="iconsminds-statistic"
            headerIconClass="success"
            @track-logs-back="${x => x.clearSelectedGroup()}"
            @track-logs-open="${x => x.goToGroup(x.selectedGroup)}"
            @track-log-handled="${x => x.onTrackLogHandled()}">
        </track-logs>
        `)}

        
        ${(0, fast_element_1.when)(x => !x.isDirectMessagesMode() && !x.isEmailMode() && !!x.selectedGroup, (0, fast_element_1.html) `
        <comms-messages
            ${(0, fast_element_1.ref)('commsMessagesPreview')}
            mode="group"
            :isPreviewMode="${x => true}"
            :groupId="${x => { var _a; return ((_a = x.selectedGroup) === null || _a === void 0 ? void 0 : _a.id) || ''; }}"
            :groupWaId="${x => { var _a; return ((_a = x.selectedGroup) === null || _a === void 0 ? void 0 : _a.groupWaId) || ''; }}"
            :phoneNumber="${x => { var _a; return ((_a = x.selectedGroup) === null || _a === void 0 ? void 0 : _a.phoneNumber) || ''; }}"
            :communicationType="${x => { var _a; return ((_a = x.selectedGroup) === null || _a === void 0 ? void 0 : _a.communicationType) || 'WA'; }}"
            :agentActive="${x => x.agentActive}"
            maxMsg="5"
        ></comms-messages>
        `)}

        
        ${(0, fast_element_1.when)(x => x.isDirectMessagesMode(), (0, fast_element_1.html) `
        <comms-stats-alerts
            ${(0, fast_element_1.ref)('statsAlerts')}
            mode="directMessages"
            :items="${x => x.dmContacts}"
            :trackLogs="${x => x.allDmTrackLogs}">
        </comms-stats-alerts>
        `)}

        
        ${(0, fast_element_1.when)(x => x.isDirectMessagesMode() && x.settingsId, (0, fast_element_1.html) `
        <track-logs
            settingsId="${x => String(x.settingsId)}"
            mode="directMessages"
            :authorLid="${x => x.selectedDmContact ? x.selectedDmContact.authorLid : null}"
            :headerTitle="${x => x.selectedDmContact ? (x.selectedDmContact.authorName || x.selectedDmContact.authorLid) + ' — ' + 'whatsapp.directMessages.trackLogs'.t() : 'whatsapp.directMessages.trackLogs'.t()}"
            :showBackButton="${x => !!x.selectedDmContact}"
            :showOpenButton="${x => !!x.selectedDmContact}"
            headerIcon="iconsminds-speach-bubble-dialog"
            headerIconClass="primary"
            @track-logs-back="${x => x.clearSelectedDmContact()}"
            @track-logs-open="${x => x.viewDmContactDetail()}"
            @track-log-handled="${x => x.onTrackLogHandled()}">
        </track-logs>
        `)}

        
        ${(0, fast_element_1.when)(x => x.isDirectMessagesMode() && !!x.selectedDmContact, (0, fast_element_1.html) `
        <comms-messages
            ${(0, fast_element_1.ref)('commsMessagesPreview')}
            mode="dm"
            :isPreviewMode="${x => true}"
            :settingsId="${x => String(x.settingsId)}"
            :authorLid="${x => { var _a; return ((_a = x.selectedDmContact) === null || _a === void 0 ? void 0 : _a.authorLid) || ''; }}"
            :phoneNumber="${x => x.phoneNumber}"
            :communicationType="${x => { var _a; return ((_a = x.selectedDmContact) === null || _a === void 0 ? void 0 : _a.communicationType) || 'WA'; }}"
            :agentActive="${x => x.agentActive}"
            :contactName="${x => { var _a; return ((_a = x.selectedDmContact) === null || _a === void 0 ? void 0 : _a.authorName) || ''; }}"
            maxMsg="5"
        ></comms-messages>
        `)}

        
        ${(0, fast_element_1.when)(x => x.isEmailMode(), (0, fast_element_1.html) `
        <comms-stats-alerts
            ${(0, fast_element_1.ref)('statsAlerts')}
            mode="email"
            :items="${x => x.emailContacts}"
            :trackLogs="${x => x.allEmailTrackLogs}">
        </comms-stats-alerts>
        `)}

        
        ${(0, fast_element_1.when)(x => x.isEmailMode() && x.settingsId, (0, fast_element_1.html) `
        <track-logs
            settingsId="${x => String(x.settingsId)}"
            mode="email"
            :emailAddress="${x => x.selectedEmailContact ? x.selectedEmailContact.emailAddress : null}"
            :headerTitle="${x => x.selectedEmailContact ? (x.selectedEmailContact.senderName || x.selectedEmailContact.emailAddress) + ' — ' + 'whatsapp.email.trackLogs'.t() : 'whatsapp.email.trackLogs'.t()}"
            :showBackButton="${x => !!x.selectedEmailContact}"
            :showOpenButton="${x => false}"
            headerIcon="iconsminds-envelope"
            headerIconClass="info"
            @track-logs-back="${x => x.clearSelectedEmailContact()}"
            @track-log-handled="${x => x.onTrackLogHandled()}">
        </track-logs>
        `)}

    </div>

</div>

${(0, fast_element_1.when)(x => x.joinModalOpen, (0, fast_element_1.html) `
<rws-modal header="whatsapp.groups.joinLink.modalTitle" centerTop="true" :closeModal="${x => x.closeJoinModal.bind(x)}">
    <div class="join-group-modal-body">
        <p class="join-group-hint">${'whatsapp.groups.joinLink.hint'.t()}</p>
        <the-form :onSubmit="${x => x.submitJoinGroup.bind(x)}">
            <part-input class="form-part" required="true" name="joinInviteLink" label="whatsapp.groups.joinLink.label" placeholder="whatsapp.groups.joinLink.placeholder" :value="${x => x.joinInviteLink}" :onChange="${x => x.handleJoinLinkChange.bind(x)}"></part-input>
            <div class="d-flex justify-content-end mt-3" style="gap: 8px;">
                <button type="button" class="btn btn-secondary btn-sm" @click="${x => x.closeJoinModal()}">${'whatsapp.groups.joinLink.cancel'.t()}</button>
                <button type="submit" class="btn btn-success btn-sm" ?disabled="${x => x.joinLoading || !x.joinInviteLink}">
                    ${(0, fast_element_1.when)(x => x.joinLoading, (0, fast_element_1.html) `<app-loader block="true" width="12px" height="12px"></app-loader>`)}
                    ${'whatsapp.groups.joinLink.submit'.t()}
                </button>
            </div>
        </the-form>
    </div>
</rws-modal>
`)}`;
require("./styles/layout.scss");
const styles = T.css `.wa-groups-dashboard {
  display: flex;
  height: calc(100vh - 200px);
  min-height: 500px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
}

.wa-gd-sidebar {
  width: 320px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #d7d7d7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wa-gd-sidebar-header {
  flex-shrink: 0;
}

.wa-gd-search {
  padding-left: 30px !important;
  border: 1px solid #d7d7d7 !important;
}

.wa-gd-filter-btn {
  flex: 1;
  padding: 5px 4px;
  border: 1px solid #d7d7d7;
  background: #f5f6f8;
  color: #333;
  font-size: 0.72rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.12s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.wa-gd-filter-btn:first-child {
  border-radius: 4px 0 0 4px;
}
.wa-gd-filter-btn:last-child {
  border-radius: 0 4px 4px 0;
  border-left: none;
}
.wa-gd-filter-btn:not(:first-child) {
  border-left: none;
}
.wa-gd-filter-btn:hover {
  background: #ececec;
}
.wa-gd-filter-btn.active {
  background: #3b82f6;
  color: #fff;
  font-weight: 700;
  border-color: #2563eb;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
}
.wa-gd-filter-btn.active .wa-gd-count {
  color: rgba(255, 255, 255, 0.8);
}

.wa-gd-count {
  font-weight: normal;
  color: #888;
  font-size: 0.68rem;
}

.wa-gd-sidebar-list {
  flex: 1;
  overflow-y: auto;
}

.wa-gd-sidebar-item {
  display: block;
  width: 100%;
  padding: 11px 14px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.12s ease;
}
.wa-gd-sidebar-item:hover {
  background: #f5f5f5;
}

.wa-gd-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
}

.wa-gd-sidebar-footer {
  flex-shrink: 0;
}

.wa-gd-center {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
}

.wa-gd-stat-card {
  padding-top: 0 !important;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.wa-gd-messages-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.wa-gd-messages-panel .card-header {
  flex-shrink: 0;
}

.wa-gd-messages-body {
  flex: 1;
  overflow-y: auto;
  min-height: 260px;
  max-height: 440px;
  background: #f8f9fa;
}

.wa-gd-msg-list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 6px;
}

.wa-gd-msg-item {
  background: #fff;
  border-radius: 6px;
  padding: 7px 10px;
  border: 1px solid #e9ecef;
  font-size: 0.82rem;
  line-height: 1.4;
}
.wa-gd-msg-item .wa-gd-msg-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}
.wa-gd-msg-item .wa-gd-msg-sender {
  font-weight: 600;
  color: #28a745;
}
.wa-gd-msg-item .wa-gd-msg-time {
  color: #adb5bd;
  font-size: 0.72rem;
  margin-left: auto;
  flex-shrink: 0;
}
.wa-gd-msg-item .wa-gd-msg-body {
  color: #343a40;
  word-break: break-word;
}

.wa-gd-tracklogs-section {
  background: #fff;
}

.wa-gd-tracklogs-header {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa !important;
}

.wa-gd-tracklogs-list {
  overflow-y: auto;
}

.wa-gd-tracklog-item {
  font-size: 0.8rem;
  background: #fff;
  transition: all 0.12s ease;
}
.wa-gd-tracklog-item:last-child {
  border-bottom: none !important;
}
.wa-gd-tracklog-item:hover {
  background: #f8f9fa;
}

.wa-gd-tracklog-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.loading_groups {
  margin-top: 50px;
  text-align: center;
  color: #888;
}

.whatsapp-dm-detail {
  width: 100%;
}
.whatsapp-dm-detail .top-right-button-container {
  float: right;
}

.comms-group-list-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
.comms-group-list-header h1 {
  margin-bottom: 0;
}

.comms-group-list-actions {
  flex-shrink: 0;
}

.comms-group-list-contact-info {
  padding-top: 0 !important;
}

.comms-group-list-summaries {
  padding-top: 0 !important;
}

.comms-group-list-messages {
  padding-top: 0 !important;
  display: flex;
  flex-direction: column;
}

.comms-group-list-messages-controls {
  flex-shrink: 0;
}

.comms-group-list-messages-list {
  flex: 1;
  overflow-y: auto;
  min-height: 260px;
  max-height: 500px;
}

.comms-group-list-send-message {
  padding-top: 0 !important;
}

.comms-group-list-members {
  padding-top: 0 !important;
}

.comms-group-list-add-participants {
  padding-top: 0 !important;
}

.comms-group-list-bot-settings {
  padding-top: 0 !important;
}

.card {
  padding-top: 1.5rem;
}

.summary-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1040;
}

.summary-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;
  background: #fff;
  box-shadow: -8px 0 28px rgba(0, 0, 0, 0.18);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767.98px) {
  .summary-drawer {
    width: 100vw;
  }
}

.summary-drawer-body {
  overflow-y: auto;
  flex: 1;
}

.messages-list {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.messages-list .message-item:nth-child(odd) {
  background-color: rgb(243, 243, 243) !important;
}

.message-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.message-item:last-child {
  border-bottom: none;
}
.message-item--agent {
  background-color: #e8f5e9 !important;
}
.message-item__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.message-item__sender {
  font-weight: 600;
  font-size: 0.85rem;
  color: #333;
}
.message-item__time {
  font-size: 0.75rem;
  color: #999;
}
.message-item__body {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
  word-break: break-word;
}
.message-item__media {
  margin-top: 8px;
}

.text-muted-small {
  font-size: 0.72rem;
  color: #888;
}

.text-truncate-max {
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-comms-type {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
}
.badge-comms-type.wa {
  background-color: #25d366;
  color: #fff;
}
.badge-comms-type.tele {
  background-color: #0088cc;
  color: #fff;
}

.badge-tracking {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #198754;
  color: #fff;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.join-group-hint {
  color: #666;
  font-size: 0.9rem;
}

.join-group-modal-body {
  padding: 8px 0;
}

.wa-green-text {
  color: #25d366 !important;
}

.info-text {
  color: #17a2b8 !important;
}

.primary-text {
  color: #3b82f6 !important;
}

.success-text {
  color: #28a745 !important;
}

.warning-text {
  color: #ffc107 !important;
}

.danger-text {
  color: #dc3545 !important;
}

.text-secondary {
  color: #555 !important;
}

.contact-info-card-primary {
  background: #f0f9ff;
  border: 1px solid #bee3f8;
}
.contact-info-card-primary strong {
  font-size: 1.05rem;
  color: #1a1a2e;
}

.contact-info-card-secondary {
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
}

.font-monospace {
  font-family: monospace;
}

.word-break-all {
  word-break: break-all;
}

.summaries-table th {
  white-space: nowrap;
}

.stat-icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.stat-icon-circle.success {
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.25);
  color: #28a745;
}
.stat-icon-circle.danger {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.25);
  color: #dc3545;
}
.stat-icon-circle.warning {
  background-color: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.25);
  color: #ffc107;
}
.stat-icon-circle.primary {
  background-color: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.25);
  color: #3b82f6;
}
.stat-icon-circle.info {
  background-color: rgba(23, 162, 184, 0.1);
  border: 1px solid rgba(23, 162, 184, 0.25);
  color: #17a2b8;
}

.sidebar-item-content {
  min-width: 0;
  flex: 1;
}
.sidebar-item-content .item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
  gap: 8px;
}
.sidebar-item-content .item-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}
.sidebar-item-content .item-badges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}
.sidebar-item-content .item-status {
  display: flex;
  align-items: center;
  gap: 3px;
}
.sidebar-item-content .status-dot-sm {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.sidebar-item-content .status-label {
  font-size: 0.68rem;
  font-weight: 600;
}
.sidebar-item-content .item-comment {
  font-size: 0.72rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.badge-tracking-sm {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #198754;
  color: #fff;
}

.badge-comms-sm {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
}
.badge-comms-sm.wa {
  background-color: #25d366;
  color: #fff;
}
.badge-comms-sm.tele {
  background-color: #0088cc;
  color: #fff;
}
.badge-comms-sm.email {
  background-color: var(--primary-color);
  color: #fff;
}

.badge-count-sm {
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #6c757d;
  color: #fff;
}

.badge-count-info {
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #17a2b8;
  color: #fff;
}

.wa-gd-tracklog-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.wa-gd-tracklog-badge.critical {
  background-color: #dc3545;
  color: #fff;
}
.wa-gd-tracklog-badge.warning {
  background-color: #ffc107;
  color: #212529;
}
.wa-gd-tracklog-badge.good {
  background-color: #28a745;
  color: #fff;
}
.wa-gd-tracklog-badge.neutral {
  background-color: #6c757d;
  color: #fff;
}

.card-header-icon {
  margin-right: 0.5rem;
}
.card-header-icon.success {
  color: #28a745;
}
.card-header-icon.primary {
  color: #3b82f6;
}
.card-header-icon.info {
  color: #17a2b8;
}
.card-header-icon.wa-green {
  color: #25d366;
}

.tracklog-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
}

.tracklog-summary {
  font-size: 0.75rem;
  line-height: 1.4;
  color: #888;
}

.tracklog-timestamp {
  font-size: 0.7rem;
  color: #888;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.tracklog-group-name {
  font-size: 0.7rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tracklog-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.tracklog-header-actions {
  display: flex;
  gap: 6px;
}

.card-header-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0;
}

.handler-switch {
  display: inline-flex;
  align-items: center;
}

:host {
  display: block;
  width: 100%;
  height: 100%;
}`;
const shadowOptions = { "mode": "open" };
let WaGroupList = class WaGroupList extends client_1.RWSViewComponent {
    get allowedPhoneNumbersList() {
        return this.phoneNumbers || [];
    }
    constructor(wsService) {
        super();
        this.wsService = wsService;
        this.phoneNumber = '';
        this.phoneNumbers = [];
        this.mode = 'groups'; // 'groups' | 'directMessages' | 'email'
        this.groups = [];
        this.filteredGroups = [];
        this.loading = false;
        this.agentActive = false;
        this.search = '';
        this.filter = 'all';
        this.joinModalOpen = false;
        this.joinInviteLink = '';
        this.joinLoading = false;
        this.selectedGroup = null;
        this.previewMessages = [];
        this.previewLoading = false;
        this.allTrackLogs = [];
        this.countLogs = [];
        this.criticalGroupCount = 0;
        this.actionGroupCount = 0;
        // Direct messages mode
        this.dmContacts = [];
        this.filteredDmContacts = [];
        this.selectedDmContact = null;
        this.allDmTrackLogs = [];
        // Email mode
        this.emailContacts = [];
        this.filteredEmailContacts = [];
        this.selectedEmailContact = null;
        this.allEmailTrackLogs = [];
        this.lastPage = 0;
        this.allGroupsLoaded = false;
        this.scrollPageEnabled = true;
        this.previousScrollTop = null;
        this.groupListElement = null;
        this.statsAlerts = null;
        this.commsMessagesPreview = null;
        this._searchDebounceTimer = null;
        this._groupsRequestPending = false;
        this._loadedPages = new Set();
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.settingsId) {
            if (this.isEmailMode()) {
                await this.loadEmailContacts();
                this.loadAllEmailTrackLogs();
            }
            else if (this.isDirectMessagesMode()) {
                await this.loadDmContacts();
                this.loadAllDmTrackLogs();
            }
            else {
                await this.loadGroups();
                this.loadAllTrackLogs();
            }
        }
        this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || String(data.settingsId) !== String(this.settingsId))
                return;
            this.joinLoading = false;
            if (data.success) {
                this.notifyService.notify('whatsapp.groups.joinLink.success'.t(), 'info');
                this.joinModalOpen = false;
                this.joinInviteLink = '';
                this.loadGroups();
            }
            else {
                this.notifyService.notify(data.error || 'whatsapp.groups.joinLink.failed'.t(), 'error');
            }
        }, 'comms_join_group_result');
        this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || String(data.settingsId) !== String(this.settingsId))
                return;
            // Refresh preview if the new message belongs to the selected group
            if (this.selectedGroup && data.groupId === this.selectedGroup.id) {
                this.loadPreviewMessages(this.selectedGroup.id);
            }
        }, 'comms_new_group_message');
        // Track log WS listener: parent only refreshes allTrackLogs for stats/filters.
        // The <track-logs> component handles its own filtered list refresh.
        this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || String(data.settingsId) !== String(this.settingsId))
                return;
            if (this.isEmailMode()) {
                this.loadAllEmailTrackLogs();
            }
            else if (this.isDirectMessagesMode()) {
                this.loadAllDmTrackLogs();
            }
            else {
                this.loadAllTrackLogs();
            }
        }, 'comms_track_log_created');
        this.mindGroupScroll();
        this.on('track-log-handled', () => {
            this.onTrackLogHandled();
        });
    }
    async onTrackLogHandled() {
        if (this.isEmailMode()) {
            await this.loadAllEmailTrackLogs();
        }
        else if (this.isDirectMessagesMode()) {
            await this.loadAllDmTrackLogs();
        }
        else {
            await this.loadAllTrackLogs();
        }
        // Force stats component to recalculate
        if (this.statsAlerts) {
            this.statsAlerts.trackLogs = [...(this.isEmailMode() ? this.allEmailTrackLogs : this.isDirectMessagesMode() ? this.allDmTrackLogs : this.countLogs)];
        }
    }
    settingsIdChanged(oldValue, newValue) {
        if (newValue) {
            this.resetAndReload();
        }
    }
    async resetAndReload() {
        // Reset data
        this.groups = [];
        this.lastPage = 0;
        this.allGroupsLoaded = false;
        this._loadedPages.clear();
        this.dmContacts = [];
        this.filteredDmContacts = [];
        this.emailContacts = [];
        this.filteredEmailContacts = [];
        this.selectedGroup = null;
        this.selectedDmContact = null;
        this.selectedEmailContact = null;
        this.allTrackLogs = [];
        this.allDmTrackLogs = [];
        this.allEmailTrackLogs = [];
        this.countLogs = [];
        this.search = '';
        if (this.isEmailMode()) {
            await this.loadEmailContacts();
            this.loadAllEmailTrackLogs();
        }
        else if (this.isDirectMessagesMode()) {
            await this.loadDmContacts();
            this.loadAllDmTrackLogs();
        }
        else {
            await this.loadGroups();
            this.loadAllTrackLogs();
        }
    }
    async loadGroups(scrollToBottom = false) {
        if (!this.settingsId) {
            return;
        }
        if (this._groupsRequestPending) {
            return;
        }
        if (this.allGroupsLoaded) {
            return;
        }
        const nextPage = this.lastPage + 1;
        // Check if this page has already been loaded to prevent duplicates
        if (this._loadedPages.has(nextPage)) {
            return;
        }
        this._groupsRequestPending = true;
        this.loading = true;
        try {
            const opts = {
                routeParams: { settingsId: String(this.settingsId) }
            };
            const allowed = this.allowedPhoneNumbersList;
            const page = String(nextPage);
            opts.queryParams = {
                page
            };
            if (allowed.length > 0) {
                opts.queryParams['phoneNumbers'] = allowed.join(',');
            }
            if (this.search && this.search.trim()) {
                opts.queryParams['search'] = this.search.trim();
            }
            const response = await this.apiService.back.get('whatsapp.groups.list', opts);
            if (response && response.success && Array.isArray(response.data)) {
                if (response.data.length === 0) {
                    this.allGroupsLoaded = true;
                    this.computeFiltered(scrollToBottom);
                }
                else {
                    // Mark page as loaded and update lastPage only after successful data retrieval
                    this._loadedPages.add(nextPage);
                    this.lastPage = nextPage;
                    this.groups = [...this.groups, ...response.data];
                    this.computeFiltered(scrollToBottom);
                }
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.groups.loadFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.groups.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
            this._groupsRequestPending = false;
        }
    }
    /**
     * Reload groups from scratch (reset pagination) — used when search query changes.
     */
    async reloadGroups() {
        this.groups = [];
        this.lastPage = 0;
        this.allGroupsLoaded = false;
        this._loadedPages.clear();
        await this.loadGroups();
    }
    groupsChanged() { this.computeFiltered(); this.updateGroupCounts(); }
    searchChanged() {
        console.log('searchchanged');
        // For DM and email modes, client-side filtering is sufficient
        this.computeFilteredDm();
        this.computeFilteredEmail();
        // For groups mode, debounce and call backend to search server-side
        if (this._searchDebounceTimer) {
            clearTimeout(this._searchDebounceTimer);
        }
        this._searchDebounceTimer = setTimeout(() => {
            if (!this.isDirectMessagesMode() && !this.isEmailMode()) {
                this.reloadGroups();
            }
            else {
                this.computeFiltered();
            }
        }, 300);
    }
    filterChanged() { this.computeFiltered(); }
    allTrackLogsChanged() { this.updateCountLogs(); this.computeFiltered(); this.updateGroupCounts(); }
    selectedGroupChanged() { this.updateCountLogs(); }
    emailContactsChanged() { this.computeFilteredEmail(); }
    allEmailTrackLogsChanged() { this.computeFilteredEmail(); }
    selectedEmailContactChanged() { this.updateEmailCountLogs(); }
    updateGroupCounts() {
        const logs = this.allTrackLogs;
        const groups = this.groups;
        this.criticalGroupCount = groups.filter(g => logs.some(l => l.groupId === g.id && !l.isHandled && l.logType === 'critical')).length;
        this.actionGroupCount = groups.filter(g => logs.some(l => l.groupId === g.id && !l.isHandled && l.logType === 'warning')).length;
    }
    updateCountLogs() {
        if (this.selectedGroup) {
            this.countLogs = this.allTrackLogs.filter(l => l.groupId === this.selectedGroup.id);
        }
        else {
            this.countLogs = this.allTrackLogs;
        }
    }
    updateEmailCountLogs() {
        // Email track logs filtering is now handled by the <track-logs> component
    }
    getGroupLatestLogType(groupId) {
        const logs = this.allTrackLogs.filter(l => l.groupId === groupId);
        if (!logs.length)
            return null;
        const unhandled = logs.filter(l => !l.isHandled);
        if (!unhandled.length)
            return backendImport_2.TrackLogType.Neutral;
        // Priority: critical > warning > good > neutral
        const priority = [backendImport_2.TrackLogType.Critical, backendImport_2.TrackLogType.Warning, backendImport_2.TrackLogType.Good, backendImport_2.TrackLogType.Neutral];
        for (const type of priority) {
            if (unhandled.some(l => l.logType === type))
                return type;
        }
        return unhandled[0].logType || null;
    }
    getDmContactLatestLogType(authorLid) {
        const logs = this.allDmTrackLogs.filter(l => l.authorLid === authorLid);
        if (!logs.length)
            return null;
        const unhandled = logs.filter(l => !l.isHandled);
        if (!unhandled.length)
            return backendImport_2.TrackLogType.Neutral;
        const priority = [backendImport_2.TrackLogType.Critical, backendImport_2.TrackLogType.Warning, backendImport_2.TrackLogType.Good, backendImport_2.TrackLogType.Neutral];
        for (const type of priority) {
            if (unhandled.some(l => l.logType === type))
                return type;
        }
        return unhandled[0].logType || null;
    }
    getEmailContactLatestLogType(emailAddress) {
        const logs = this.allEmailTrackLogs.filter(l => l.authorLid === emailAddress);
        if (!logs.length)
            return null;
        const unhandled = logs.filter(l => !l.isHandled);
        if (!unhandled.length)
            return backendImport_2.TrackLogType.Neutral;
        const priority = [backendImport_2.TrackLogType.Critical, backendImport_2.TrackLogType.Warning, backendImport_2.TrackLogType.Good, backendImport_2.TrackLogType.Neutral];
        for (const type of priority) {
            if (unhandled.some(l => l.logType === type))
                return type;
        }
        return unhandled[0].logType || null;
    }
    async loadAllDmTrackLogs() {
        try {
            const queryParams = { dm: 'true' };
            const allowed = this.allowedPhoneNumbersList;
            if (allowed.length > 0) {
                queryParams['phoneNumbers'] = allowed.join(',');
            }
            const response = await this.apiService.back.get('whatsapp.trackLogs.all', { routeParams: { settingsId: String(this.settingsId) }, queryParams });
            if (response && response.success && Array.isArray(response.data)) {
                this.allDmTrackLogs = response.data.filter(l => !l.groupId && !!l.authorLid);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadAllEmailTrackLogs() {
        try {
            const queryParams = {};
            const allowed = this.allowedPhoneNumbersList;
            if (allowed.length > 0) {
                queryParams['phoneNumbers'] = allowed.join(',');
            }
            const response = await this.apiService.back.get('whatsapp.email.trackLogs.all', { routeParams: { settingsId: String(this.settingsId) }, queryParams });
            if (response && response.success && Array.isArray(response.data)) {
                this.allEmailTrackLogs = response.data.filter(l => !!l.authorLid);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    computeFiltered(scrollToBottom = false) {
        let result = this.groups || [];
        const q = (this.search || '').toLowerCase().trim();
        const f = this.filter || 'all';
        // Only do client-side filtering for groups mode if there's NO search query
        // (when there IS a search query, the backend already filtered the results)
        if (q && this.isDirectMessagesMode() === false && this.isEmailMode() === false) {
            // Skip client-side filtering for groups mode - backend already did it
        }
        else if (q) {
            result = result.filter(g => {
                var _a, _b;
                return ((_a = g.groupName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(q)) ||
                    ((_b = g.groupStatusComment) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(q));
            });
        }
        if (f === 'critical') {
            result = result.filter(g => this.allTrackLogs.some(l => l.groupId === g.id && !l.isHandled && l.logType === backendImport_2.TrackLogType.Critical));
        }
        else if (f === 'action') {
            result = result.filter(g => this.allTrackLogs.some(l => l.groupId === g.id && !l.isHandled && l.logType === backendImport_2.TrackLogType.Warning));
        }
        // Tracked groups on top
        result = [
            ...result.filter(g => g.tracking),
            ...result.filter(g => !g.tracking)
        ];
        this.filteredGroups = result;
        if (scrollToBottom) {
            setTimeout(() => {
                const listElement = this.groupListElement;
                if (listElement) {
                    console.log('5. [Scroll Debug] Element dimensions before scroll:', {
                        scrollHeight: listElement.scrollHeight,
                        clientHeight: listElement.clientHeight,
                        currentScrollTop: listElement.scrollTop,
                        maxPossibleScroll: listElement.scrollHeight - listElement.clientHeight
                    });
                    listElement.scrollTop = listElement.clientHeight - 120;
                    this.scrollPageEnabled = false;
                    const targetScroll = listElement.scrollHeight - listElement.clientHeight - 120;
                    console.log('6. [Scroll Debug] Attempting to set scrollTop to:', targetScroll);
                    listElement.scrollTop = targetScroll;
                    this.scrollPageEnabled = false;
                    console.log('7. [Scroll Debug] Verified scrollTop after assignment:', listElement.scrollTop);
                }
            }, 100);
        }
    }
    setFilter(f) { this.filter = f; }
    handleSearchInput(event) { this.search = event.target.value; }
    selectGroup(group) {
        this.selectedGroup = group;
        // Force comms-messages to reload with new groupId
        setTimeout(() => {
            var _a;
            (_a = this.commsMessagesPreview) === null || _a === void 0 ? void 0 : _a.reload();
        }, 100);
    }
    clearSelectedGroup() {
        this.selectedGroup = null;
    }
    async loadAllTrackLogs() {
        try {
            const queryParams = {};
            const allowed = this.allowedPhoneNumbersList;
            if (allowed.length > 0) {
                queryParams['phoneNumbers'] = allowed.join(',');
            }
            const response = await this.apiService.back.get('whatsapp.trackLogs.all', { routeParams: { settingsId: String(this.settingsId) }, queryParams });
            if (response && response.success && Array.isArray(response.data)) {
                this.allTrackLogs = response.data;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadPreviewMessages(groupId) {
        this.previewLoading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.groups.messages', { routeParams: { id: groupId }, queryParams: { limit: '50' } });
            if (response && response.success && Array.isArray(response.data)) {
                this.previewMessages = response.data;
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.previewLoading = false;
        }
    }
    getStatusColor(status) {
        if (status === 'critical')
            return '#dc3545';
        if (status === 'warning')
            return '#ffc107';
        if (status === 'good')
            return '#28a745';
        return '#6c757d';
    }
    getStatusLabel(status) {
        if (status === 'critical')
            return 'whatsapp.dashboard.aiStatus.critical'.t();
        if (status === 'warning')
            return 'whatsapp.dashboard.aiStatus.warning'.t();
        if (status === 'good')
            return 'whatsapp.dashboard.aiStatus.good'.t();
        return 'whatsapp.dashboard.aiStatus.neutral'.t();
    }
    getStatusBgStyle(status) {
        return `background-color: ${this.getStatusColor(status)};`;
    }
    getStatusColorStyle(status) {
        return `color: ${this.getStatusColor(status)};`;
    }
    goToGroup(group) {
        component_1.SiteMenu.goto.bind(this)(`/settings/comms/group/${encodeURIComponent(group.id)}`);
    }
    goToCreateGroup() {
        if (!this.settingsId) {
            this.notifyService.notify('whatsapp.groups.settingsRequired'.t(), 'error');
            return;
        }
        component_1.SiteMenu.goto.bind(this)(`/settings/comms/group/create/${this.settingsId}`);
    }
    goToCreateNumber() {
        component_1.SiteMenu.goto.bind(this)(`/settings/comms/create`);
    }
    openJoinModal() {
        this.joinInviteLink = '';
        this.joinModalOpen = true;
    }
    closeJoinModal() {
        this.joinModalOpen = false;
    }
    handleJoinLinkChange(event, value) {
        this.joinInviteLink = value || '';
    }
    async submitJoinGroup() {
        const raw = this.joinInviteLink.trim();
        if (!raw) {
            this.notifyService.notify('whatsapp.groups.joinLink.required'.t(), 'error');
            return;
        }
        const match = raw.match(/chat\.whatsapp\.com\/([A-Za-z0-9_-]+)/);
        const inviteCode = match ? match[1] : raw;
        this.joinLoading = true;
        this.wsService.sendMessage('comms_point', 'comms_join_group', { settingsId: this.settingsId, inviteCode });
    }
    // ─── Direct Messages Mode ────────────────────────────────────────────────
    isDirectMessagesMode() {
        return this.mode === 'directMessages';
    }
    isEmailMode() {
        return this.mode === 'email';
    }
    async loadDmContacts() {
        this.loading = true;
        try {
            const opts = {
                routeParams: { settingsId: String(this.settingsId) }
            };
            const allowed = this.allowedPhoneNumbersList;
            if (allowed.length > 0) {
                opts.queryParams = { phoneNumbers: allowed.join(',') };
            }
            const response = await this.apiService.back.get('whatsapp.directMessages.list', opts);
            if (response && response.success && Array.isArray(response.data)) {
                this.dmContacts = response.data;
                this.computeFilteredDm();
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.directMessages.loadFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.directMessages.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    dmContactsChanged() { this.computeFilteredDm(); }
    computeFilteredDm() {
        let result = this.dmContacts || [];
        const q = (this.search || '').toLowerCase().trim();
        if (q) {
            result = result.filter(c => (c.authorName || '').toLowerCase().includes(q) ||
                c.authorLid.toLowerCase().includes(q));
        }
        this.filteredDmContacts = result;
    }
    selectDmContact(contact) {
        this.selectedDmContact = contact;
        // Force comms-messages to reload with new authorLid
        setTimeout(() => {
            var _a;
            (_a = this.commsMessagesPreview) === null || _a === void 0 ? void 0 : _a.reload();
        }, 100);
    }
    clearSelectedDmContact() {
        this.selectedDmContact = null;
    }
    viewDmContactDetail() {
        if (!this.selectedDmContact)
            return;
        const authorLid = this.selectedDmContact.authorLid.replace(/@lid$/, '');
        component_1.SiteMenu.goto.bind(this)(`/settings/comms/dm/${this.settingsId}--${authorLid}`);
    }
    // ─── Email Mode ──────────────────────────────────────────────────────────
    async loadEmailContacts() {
        this.loading = true;
        try {
            const opts = {
                routeParams: { settingsId: String(this.settingsId) }
            };
            const allowed = this.allowedPhoneNumbersList;
            if (allowed.length > 0) {
                opts.queryParams = { phoneNumbers: allowed.join(',') };
            }
            const response = await this.apiService.back.get('whatsapp.email.directMessages.list', opts);
            if (response && response.success && Array.isArray(response.data)) {
                this.emailContacts = response.data.map(c => ({
                    emailAddress: c.authorLid || c.emailAddress,
                    senderName: c.authorName || c.senderName,
                    senderEmail: c.authorLid || c.senderEmail,
                    messageCount: c.messageCount,
                    lastSubject: c.lastMessage || c.lastSubject,
                    lastTimestamp: c.lastTimestamp
                }));
                this.computeFilteredEmail();
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'whatsapp.email.loadFailed'.t(), 'error');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('whatsapp.email.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    computeFilteredEmail() {
        let result = this.emailContacts || [];
        const q = (this.search || '').toLowerCase().trim();
        if (q) {
            result = result.filter(c => (c.senderName || '').toLowerCase().includes(q) ||
                c.emailAddress.toLowerCase().includes(q));
        }
        this.filteredEmailContacts = result;
    }
    selectEmailContact(contact) {
        this.selectedEmailContact = contact;
    }
    clearSelectedEmailContact() {
        this.selectedEmailContact = null;
    }
    async mindGroupScroll() {
        const listElement = this.groupListElement;
        if (!listElement)
            return;
        const handleScroll = async () => {
            const previousScrollTop = this.previousScrollTop || 0;
            if (listElement.scrollTop < previousScrollTop) {
                this.previousScrollTop = listElement.scrollTop;
                return;
            }
            this.previousScrollTop = listElement.scrollTop;
            if (!this.scrollPageEnabled) {
                this.scrollPageEnabled = true;
                return;
            }
            if (this.loading || this.allGroupsLoaded)
                return;
            const scrollTop = listElement.scrollTop;
            const scrollHeight = listElement.scrollHeight;
            const clientHeight = listElement.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                await this.loadGroups(true);
            }
        };
        listElement.addEventListener('scroll', handleScroll);
        this.addEventListener('disconnected', () => {
            listElement.removeEventListener('scroll', handleScroll);
        });
    }
};
exports.WaGroupList = WaGroupList;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], WaGroupList.prototype, "phoneNumber", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Array)
], WaGroupList.prototype, "phoneNumbers", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], WaGroupList.prototype, "mode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "groups", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "filteredGroups", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "agentActive", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WaGroupList.prototype, "search", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WaGroupList.prototype, "filter", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], WaGroupList.prototype, "settingsId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "joinModalOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WaGroupList.prototype, "joinInviteLink", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "joinLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IWhatsAppGroupData !== "undefined" && backendImport_1.IWhatsAppGroupData) === "function" ? _b : Object)
], WaGroupList.prototype, "selectedGroup", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "previewMessages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "previewLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "allTrackLogs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "countLogs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], WaGroupList.prototype, "criticalGroupCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], WaGroupList.prototype, "actionGroupCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "dmContacts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "filteredDmContacts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IWhatsAppDirectMessageContact !== "undefined" && backendImport_1.IWhatsAppDirectMessageContact) === "function" ? _c : Object)
], WaGroupList.prototype, "selectedDmContact", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "allDmTrackLogs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "emailContacts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "filteredEmailContacts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], WaGroupList.prototype, "selectedEmailContact", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WaGroupList.prototype, "allEmailTrackLogs", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], WaGroupList.prototype, "lastPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "allGroupsLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WaGroupList.prototype, "scrollPageEnabled", void 0);
exports.WaGroupList = WaGroupList = __decorate([
    (0, client_1.RWSView)('wa-group-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object])
], WaGroupList);
WaGroupList.defineComponent();
